<template>
	<div class="col-12 col-md-6 col-xl-3 kanban-coluna-atrasados">
		<div class="text-center tituloColuna colunaAtrasados">
            <el-tooltip content="Todos os períodos" placement="top">
			    <div class="central">
				    <i class="fas fa-exclamation-triangle mr-2"></i> Atrasado ({{ itens.length }})
                </div>
            </el-tooltip>
		</div>
		<div id="accordionAtrasadosSemana">
			<div v-for="item in itens" :key="identificador(item)" class="cartaoIndividual cartaoAtrasado clickableKanban">
				<button
					type="button"
					class="resumo-atrasado"
					:id="'heading' + identificador(item)"
					data-toggle="collapse"
					:data-target="'#collapse' + identificador(item)"
					aria-expanded="false"
					:aria-controls="'collapse' + identificador(item)">
					<div class="divTitulo">
						<el-tooltip v-if="ehAtividade && item.destaque" content="Atividade em destaque" placement="top">
							<i class="text-warning fas fa-star mr-1"></i>
						</el-tooltip>
						{{ item.titulo.length > 100 ? item.titulo.substring(0, 100) + '... (' + item.codigo + ')' : item.nomeCodigo }}
					</div>
					<div class="datas-atrasado">
						<span>{{ item.dataInicio }} a {{ item.dataFim }}</span>
						<span class="corAtrasada">Atrasada</span>
					</div>
				</button>
				<div
					:id="'collapse' + identificador(item)"
					class="collapse mt-3"
					:aria-labelledby="'heading' + identificador(item)"
					data-parent="#accordionAtrasadosSemana">
					<div class="acoes-atrasado">
						<div class="responsaveis-atrasado">
							<img v-for="responsavel in responsaveis(item)" :key="responsavel.idusuario"
								:src="responsavel.avatar" :title="responsavel.nome" :alt="responsavel.nome"
								width="27" height="27" class="rounded-circle">
						</div>
						<div class="botoes-atrasado">
							<el-tooltip content="Visualizar Atividade" placement="top">
								<button type="button" class="acao-atrasado icones iconeReagendar" aria-label="Visualizar Atividade"
									@click="$emit('visualizar-atividade', ehAtividade ? item : item.atividade)">
									<i class="far fa-eye"></i>
								</button>
							</el-tooltip>
							<el-tooltip :content="'Alterar ' + tipoItem" placement="top">
								<button type="button" class="acao-atrasado icones iconeAlterar" :aria-label="'Alterar ' + tipoItem"
									@click="$emit(ehAtividade ? 'alterar-atividade' : 'alterar-tarefa', item)">
									<i class="fas fa-edit"></i>
								</button>
							</el-tooltip>
							<el-tooltip :content="'Cancelar ' + tipoItem" placement="top">
								<button type="button" class="acao-atrasado icones iconeCancelar" :aria-label="'Cancelar ' + tipoItem"
									@click="$emit(ehAtividade ? 'cancelar-atividade' : 'cancelar-tarefa', item)">
									<i class="far fa-calendar-times"></i>
								</button>
							</el-tooltip>
							<el-tooltip :content="'Concluir ' + tipoItem" placement="top">
								<button type="button" class="acao-atrasado icones iconeConcluir" :aria-label="'Concluir ' + tipoItem"
									@click="$emit(ehAtividade ? 'concluir-atividade' : 'concluir-tarefa', item)">
									<i class="fas fa-calendar-check"></i>
								</button>
							</el-tooltip>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--<p v-if="!itens.length" class="text-center text-muted mt-3">Nenhum item atrasado para os filtros selecionados.</p>-->
	</div>
</template>

<script>
export default {
	props: {
		selecao: { type: String, default: 'A' },
		demanda: { type: Object, required: true },
	},
	computed: {
		ehAtividade() {
			return this.selecao === 'A';
		},
		tipoItem() {
			return this.ehAtividade ? 'Atividade' : 'Tarefa';
		},
		itens() {
			const lista = this.ehAtividade ? this.demanda.listaAtividade : this.demanda.listaTarefa;
			return (lista || []).filter(item => item.situacao === 'ATRASADA');
		},
	},
	methods: {
		identificador(item) {
			return this.ehAtividade ? 'AtrasadaAtividade' + item.idatividade : 'AtrasadaTarefa' + item.idtarefa;
		},
		responsaveis(item) {
			const atividade = this.ehAtividade ? item : item.atividade;
			return atividade ? atividade.listaResponsavel || [] : [];
		},
	},
};
</script>

<style scoped>
.colunaAtrasados {
	color: #b52e2e;
	border-bottom: 1px solid #df4949;
}
.legenda-atrasados {
	font-size: 10px;
	margin: 4px 0 0;
}
.resumo-atrasado {
	display: block;
	width: 100%;
	padding: 0;
	border: 0;
	background: transparent;
	color: inherit;
	font: inherit;
	text-align: left;
	cursor: pointer;
}
.datas-atrasado {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	font-size: 10px;
	margin-top: 15px;
}
.acoes-atrasado, .botoes-atrasado {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
}
.responsaveis-atrasado img + img {
	margin-left: -10px;
}
.botoes-atrasado {
	margin-left: auto;
}
.acao-atrasado {
	border: 0;
	background: transparent;
	padding: 4px 6px;
}
</style>